import { FC } from 'react'
import { observer } from 'mobx-react'
import { IPublicUser } from '@/types'
import { UserDetailNavbar } from '@/components/organisms/UserDetailNavbar'
import { UserDetailHeaderTitle } from '@/components/molecules/UserDetailHeaderTitle'
import { UserDetailHeaderInfo } from '@/components/molecules/UserDetailHeaderInfo'
import { getUserHeaderImage } from '@/utils'
import styles from './index.module.scss'

type Props = {
  user: IPublicUser
}

// TODO: CompanyDetailHeader とコンポーネントをまとめる
export const UserDetailHeader: FC<Props> = observer(({ user }) => {
  return (
    <>
      <div className={styles.content}>
        <img src={getUserHeaderImage(user, false, true)} alt='Header' />
      </div>
      <UserDetailHeaderTitle user={user} />
      <UserDetailHeaderInfo user={user} />
      <UserDetailNavbar />
    </>
  )
})
